import axios from './axios'; 
import { handleResponse, handleError } from './response'; 


// Define your api url from any source.
// Pulling from your .env file when on the server or from localhost when locally

/** @param {string} resource */ 
const getAll = (resource, queryString) => { 
  resource = queryString ? resource + queryString : resource
  return axios 
    .get(`${resource}`) 
    .then(handleResponse) 
    .catch(handleError); 
}; 

/** @param {string} resource */ 
/** @param {string} id */ 
const getSingle = (resource, id) => { 
  return axios 
    .get(`${resource}/${id}`) 
    .then(handleResponse) 
    .catch(handleError); 
}; 

/** @param {string} resource */ 
/** @param {object} model */ 
const post = (resource, model, queryString) => { 
  resource = queryString ? resource + queryString : resource
  return axios 
    .post(`${resource}`, model) 
    .then(handleResponse) 
    .catch(handleError); 
}; 

/** @param {string} resource */ 
/** @param {object} model */ 
const put = (resource, id, model) => { 
  return axios 
    .put(`${resource}/${id}`, model) 
    .then(handleResponse) 
    .catch(handleError); 
}; 

/** @param {string} resource */ 
/** @param {object} model */ 
const patch = (resource, id, model) => { 
  return axios 
    .patch(`${resource}/${id}`, model) 
    .then(handleResponse) 
    .catch(handleError); 
}; 

/** @param {string} resource */ 
/** @param {string} id */ 
const remove = (resource, id) => { 
  return axios 
    .delete(`${resource}/${id}`) 
    .then(handleResponse) 
    .catch(handleError); 
}; 

export const apiProvider = { 
  getAll, 
  getSingle, 
  post, 
  put, 
  patch, 
  remove, 
};